export default {
  font: "#FFF",
  fontLight: "#E7DFDD",
  primary: "#A239CA",
  secondary: "#4717F6",
  background: "#0E0B10",
  itemBackgroundColor: "#0E0B09",
  TransparentBackground: "rgba(0, 0, 0, 0.9)",
  darkTransparent: "rgba(0, 0, 0, 0.5)",
  lighterWhiteTransparent: "rgba(255, 255, 255, 0.2)",
  scrollbarLighterColor: "#4717F3",
  scrollbarDarkColor: "rgba(0, 0, 0, 0.7)",
};
